<div class="md:p-3">
    <h6 class="p-mb-4">{{ 'home.widgetConnect.widgetConnectModal.widgetConnectFilters.title' | translate }}</h6>
    <div class="field-radiobutton p-mb-3">
        <input
            type="radio"
            [name]="radioButtonGroupName"
            value="mySkillsOrInterests"
            [(ngModel)]="selectedOption"
            inputId="myItems"
            (ngModelChange)="emitChanges()"
        />
        <label for="myItems" class="p-ml-2">{{ radioLabelMine }}</label>
    </div>
    <div class="field p-d-flex p-ai-center p-mb-3">
        <input
            type="radio"
            [name]="radioButtonGroupName"
            value="specificSkillsOrInterest"
            [(ngModel)]="selectedOption"
            inputId="specificItem"
            (ngModelChange)="emitChanges()"
        />
        <label for="specificItem" class="p-ml-2 p-mr-3">{{ radioLabelSpecific }}</label>
        <p-dropdown
            [options]="dropdownOptions"
            optionLabel="name"
            [(ngModel)]="selectedItem"
            [placeholder]="dropdownPlaceholder"
            [disabled]="selectedOption !== 'specificSkillsOrInterest'"
            (ngModelChange)="emitChanges()"
            [filter]="true"
            [showClear]="true"
            styleClass="p-flex-grow-1"
        >
        </p-dropdown>
    </div>
</div>
